import React, { useEffect, useState } from "react";
import HeroSlider from "../../components/Website/HeroSlider";
import OurMenu from "../../components/Website/OurMenu";
import FeaturedItems from "../../components/Website/FeaturedItems";
// import OfferCardSection from "../../components/Website/OfferCardSection";
// import PopularItems from "../../components/Website/PopularItems";
import axios from "axios";
import { apiKey } from "../../config/config";
import LocationModal from "../../components/Website/LocationModal";

export default function Webpage({
  search,
  settings,
  loader,
  showModalNav,
  setShowModalNav,
  currency
}) {
  const outlet = JSON.parse(localStorage.getItem("rms-outlet"));

  const [subCategories, setSubCategories] = useState([]);
  const [foodMenus, setFoodMenus] = useState([]);
  const [subData, setSubData] = useState([]);
  const [filters, setFilters] = useState(false);
  const [catSubCat, setCatSubCat] = useState([]);
  const [filteredFoodMenu, setFilteredFoodMenu] = useState([]);

  const handleModal = () => {
    setShowModalNav(false);
  };

  const handleCategorySelect = (category) => {
    // setSelectedCategory(category);
    setFilters(true);
    if (category.is_sub_cat !== 0) {
      setCatSubCat(
        subCategories.filter((subCat) => subCat.category_id === category.id)
      );
    } else {
      setCatSubCat([]);
    }
    setFilteredFoodMenu(
      foodMenus.filter((menu) => menu.category_id === category.id)
    );
  };

  const handleSubCatSelect = (subCat) => {
    setFilters(true);
    setFilteredFoodMenu(
      foodMenus.filter((menu) => menu.sub_category_id === subCat.id)
    );
  };

  const clearFilters = () => {
    setFilters(false);
    setFilteredFoodMenu(foodMenus);
    setCatSubCat([]);
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/subCategories`, {
        params: {
          outletId: outlet?.outlet.id,
        },
      })
      .then((res) => {
        setSubCategories(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [outlet?.outlet.id]);

  useEffect(() => {
    setFilteredFoodMenu(foodMenus);
  }, [foodMenus]);

  useEffect(() => {
    // If there's a search query, filter the food menu
    if (search) {
      setFilteredFoodMenu(
        foodMenus.filter((menu) =>
          menu.name.toLowerCase().includes(search.toLowerCase())
        )
      );
    } else {
      // If search is empty, reset the filtered menu to the original list
      setFilteredFoodMenu(foodMenus);
    }
  }, [search, foodMenus]);
  return (
    <>
      <HeroSlider loader={loader} />
      <OurMenu
        loader={loader}
        handleSelect={handleCategorySelect}
        catSubCat={catSubCat}
        handleSubCatSelect={handleSubCatSelect}
        clearFilters={clearFilters}
        filters={filters}
        
      />
      <FeaturedItems
        foodMenus={filteredFoodMenu}
        settings={settings}
        loader={loader}
        setFoodMenus={setFoodMenus}
        setSubData={setSubData}
        subData={subData}
        currency={currency}
      />
      {/* <OfferCardSection /> */}
      {/* <PopularItems /> */}
      {(!outlet || showModalNav) && <LocationModal closeModal={handleModal}  />}
    </>
  );
}
